import React, { cloneElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { BarChart3Icon, SearchIcon, SendIcon, ShareIcon, SettingsIcon, HelpCircleIcon, LogOutIcon, BotIcon } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
interface SidebarProps {
  activeModule: string;
  setActiveModule: (module: string) => void;
}
export const Sidebar = ({
  activeModule,
  setActiveModule
}: SidebarProps) => {
  const {
    logout
  } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => {
    logout();
    navigate('/login', {
      replace: true
    });
  };
  const modules = [{
    id: 'dashboard',
    name: 'Dashboard',
    icon: <BarChart3Icon size={20} data-id="element-533" />
  }, {
    id: 'leadscout',
    name: 'LeadScout',
    icon: <SearchIcon size={20} data-id="element-534" />,
    color: 'bg-blue-500'
  }, {
    id: 'smartreach',
    name: 'SmartReach',
    icon: <SendIcon size={20} data-id="element-535" />,
    color: 'bg-green-500'
  }, {
    id: 'referrocket',
    name: 'ReferRocket',
    icon: <ShareIcon size={20} data-id="element-536" />,
    color: 'bg-orange-500'
  }, {
    id: 'conversai',
    name: 'ConversAI',
    icon: <BotIcon size={20} data-id="element-537" />,
    color: 'bg-purple-500'
  }];
  return <div className="w-64 bg-white border-r border-gray-200 flex flex-col h-full" data-id="element-538">
      <div className="p-4 border-b border-gray-200 flex justify-center items-center" data-id="element-539">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3YBd7gd7d4PCmnKxZ3UB6K/nexus_datatodeals-logo.png" alt="NEXUS" className="h-10" data-id="element-540" />
      </div>
      <div className="flex-1 overflow-y-auto py-4" data-id="element-541">
        <nav className="px-2 space-y-1" data-id="element-542">
          {modules.map(module => <button key={module.id} onClick={() => setActiveModule(module.id)} className={`flex items-center w-full px-3 py-2 rounded-lg text-left transition-colors ${activeModule === module.id ? 'bg-gray-100 text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-543">
              <span className={`p-1 rounded-md mr-3 ${module.color ? module.color : 'bg-gray-400'} bg-opacity-15`} data-id="element-544">
                {cloneElement(module.icon, {
              className: module.color ? module.color.replace('bg-', 'text-') : 'text-gray-400'
            })}
              </span>
              <span className="font-medium" data-id="element-545">{module.name}</span>
            </button>)}
        </nav>
      </div>
      <div className="p-4 border-t border-gray-200" data-id="element-546">
        <div className="space-y-3" data-id="element-547">
          <button onClick={() => navigate('/settings')} className="flex items-center w-full px-3 py-2 text-gray-600 hover:bg-gray-50 hover:text-gray-900 rounded-lg transition-colors" data-id="element-548">
            <SettingsIcon size={18} className="mr-3 text-gray-400" data-id="element-549" />
            <span data-id="element-550">Settings</span>
          </button>
          <button className="flex items-center w-full px-3 py-2 text-gray-600 hover:bg-gray-50 hover:text-gray-900 rounded-lg transition-colors" data-id="element-551">
            <HelpCircleIcon size={18} className="mr-3 text-gray-400" data-id="element-552" />
            <span data-id="element-553">Help & Support</span>
          </button>
          <button onClick={handleLogout} className="flex items-center w-full px-3 py-2 text-gray-600 hover:bg-gray-50 hover:text-gray-900 rounded-lg transition-colors" data-id="element-554">
            <LogOutIcon size={18} className="mr-3 text-gray-400" data-id="element-555" />
            <span data-id="element-556">Logout</span>
          </button>
        </div>
        <div className="mt-6 px-3" data-id="element-557">
          <span className="text-xs text-gray-400" data-id="element-558">v1.56</span>
        </div>
      </div>
    </div>;
};